import type { Novidade } from './tipos';

/** Fase 2 (W7): grupo da DRE, apropriação na baixa, perda, tarifa, extrato corrido, lançar da linha e importação de títulos. */
export const novidadeFinanceiro: Novidade = {
  id: '2026-10-05-financeiro',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'financeiro',
  permissao: 'financeiro.ver',
  textos: {
    pt: {
      titulo: 'Financeiro com a DRE certa, perda e extrato corrido',
      resumo: 'Juros, multa, desconto, tarifa e perda vão para a linha certa da DRE, e cada conta tem extrato com saldo corrido.',
      passos: [
        'Em Categorias, defina o grupo da DRE e o uso automático (juros, descontos, perdas e tarifas). A filha herda do pai.',
        'Na baixa, juros e multa viram receita financeira, o desconto vira dedução e a tarifa do banco entra junto.',
        'No título em aberto, Registrar perda tira o valor do saldo e lança a perda na competência.',
        'Em Contas e caixas, Extrato mostra o saldo corrido; na Conciliação, Lançar esta linha registra tarifa ou rendimento.',
        'Em A receber e A pagar, Importar títulos traz o histórico com prévia e modelo.',
      ],
    },
    en: {
      titulo: 'Finance with the right income statement, write-offs and running balance',
      resumo: 'Interest, fines, discounts, fees and write-offs go to the right income statement line, and accounts show a running balance.',
      passos: [
        'In Categories, set the income statement group and the automatic use (interest, discounts, write-offs and fees). Children inherit it.',
        'On settlement, interest and fines become financial income, the discount becomes a deduction and the bank fee goes along.',
        'On an open document, the write-off removes the amount from the balance and records the loss in the accrual period.',
        'In Accounts and cash, Statement shows the running balance; in Reconciliation, Record this line records a fee or income.',
        'In Receivable and Payable, Import documents brings the history with preview and template.',
      ],
    },
    es: {
      titulo: 'Finanzas con el estado de resultados correcto, pérdidas y saldo corrido',
      resumo: 'Intereses, multas, descuentos, comisiones y pérdidas van a la línea correcta del estado de resultados, con saldo corrido por cuenta.',
      passos: [
        'En Categorías, define el grupo del estado de resultados y el uso automático (intereses, descuentos, pérdidas y comisiones). La hija hereda.',
        'En el cobro, intereses y multa se vuelven ingreso financiero, el descuento es deducción y la comisión del banco entra junto.',
        'En el documento abierto, la pérdida saca el valor del saldo y la registra en la competencia.',
        'En Cuentas y cajas, Extracto muestra el saldo corrido; en Conciliación, Registrar esta línea registra una comisión o un rendimiento.',
        'En Por cobrar y Por pagar, Importar documentos trae el historial con vista previa y plantilla.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-financeiro/categorias.webp', null, null, null, null],
  treinamento: { curso: 'novidades' },
  // Review r23 spec (O2): o texto é histórico; o link vai ao caminho novo (W31: Plano de contas em Cadastros > Financeiro).
  rota: '/cadastros/financeiro/categorias',
};
